'use strict';

const DocumentList = require('bunsen/models/DocumentList');
const Review = require('bunsen/models/inventory/Review');
let ReviewDocumentList;
const filterReviews = function (filter) {
    return function () {
        const reviews = this.filter(function (review) {
            return review[filter]();
        });
        return new ReviewDocumentList({ documents: reviews });
    };
};
ReviewDocumentList =  DocumentList.extend({
    model: Review,
    filterNew: filterReviews('isStatusNew'),
    filterPending: filterReviews('isStatusPending'),
    filterApproved: filterReviews('isStatusApproved'),
    filterDeleted: filterReviews('isStatusDeleted'),
    filterExpert: filterReviews('isTypeExpertReview'),
    filterRejected: filterReviews('isRejected'),
    filterDataQuality: filterReviews('isTypeDataQuality'),
    filterImageProcessing: filterReviews('isTypeImageProcessing'),
    wasRejected() {
        return this.getMetadata('itemReject') === 'true';
    }
});

module.exports = ReviewDocumentList;



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/ReviewDocumentList.es.js